@if (listing?.ready) {
<!-- listing tools -->
<product-listing-tools class="block m-t-6 m-t-4-s m-t-4-m"
                       [listing]="localListing" />

<div class="m-t-6 m-t-3-s m-t-3-m m-b-3-s m-b-3-m"
     cy-searchProductsListing
     cy-listingProductsGrid
     (infiniteScroll)="listing?.increaseLimit()"
     [infinitScrollActive]="(listing?.getLimit() || 0) < 72">
    <!-- empty list -->
    @if (listing?.ready && !listing?.length) {
    <p class="p-a center"
       cy-searchNoResults>
        {{'There are no results matching your selection.' | translate}}
    </p>
    }

    <!-- product list -->
    <div [grid]="listing?.plugin?.grid?.gridSize()"
         [gridColumnGap]="listing?.plugin?.grid?.getGutterCol() || 0"
         [gridRowGap]="listing?.plugin?.grid?.getGutterRow() || 0">
        @for (model of localListing.models; track model; let index = $index) {
        <product [gridSize]="listing?.plugin?.grid?.gridSize()"
                 [model]="model"
                 [listPosition]="index + 1"
                 [listName]="context === 'search' ? 'Search results' : ''"
                 [sendTracking]="true"
                 [category]="category"
                 [searchTerm]="context === 'search' ? searchResult?.term : ''"
                 [gridColumn]="listing?.plugin?.grid?.colspan(model)"
                 [gridRowSpan]="listing?.plugin?.grid?.rowspan(model)"
                 [listing]="localListing"
                 [hideSwatches]="!!model?.data?.mattressprodtype"
                 [showReviews]="true"
                 [class.view-priority]="index<3"
                 style="visibility:hidden;"
                 cy-listingProduct>
        </product>
        }
    </div>
</div>

<!-- view more and qty viewed - no point showing below at least few elements -->
<ng-container *afterContentInit>
    @if ((listing?.length || 0) > 6) {
    <div class="m-t-8 p-t-10 center">
        <!-- number of viewed elements  -->
        <p class="p1 col-1">
            {{ 'You’ve viewed % of % products' | translate : ((listing?.getLimit() || 0) < (listing?.length || 0) ? (listing?.getLimit() || 0) : (listing?.length || 0)) : (listing?.length || 0) }}
        </p>

        <!-- view more button -->
        @if ((listing?.getLimit() || 0) < (listing?.length || 0)) {
          <button class="view-mode-button p1 bg-col-w p-r-2 p-l-2 b-a b-col-1 m-t-5"
                  role="button"
                  (click)="listing?.increaseLimit()"
                  [attr.aria-label]="'View more' | translate">
                {{'View more' | translate}}
          </button>
        }
    </div>
    }
</ng-container>
}